var map = {
	"./icon-1ST.png": "0c3c",
	"./icon-2ND.png": "019c",
	"./icon-3RD.png": "1d5f",
	"./icon-FCP.png": "0653",
	"./icon-GTS.png": "06c0",
	"./icon-ISS.png": "7fc3",
	"./icon-PCP.png": "cf47",
	"./icon-PDC.png": "06c1",
	"./icon-S.png": "a737",
	"./icon-Turbo.png": "a1f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f80f";